import { render } from "./Pledge.vue?vue&type=template&id=7c5264d3&scoped=true"
import script from "./Pledge.vue?vue&type=script&lang=js"
export * from "./Pledge.vue?vue&type=script&lang=js"

import "./Pledge.vue?vue&type=style&index=0&id=7c5264d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5264d3"]])

export default __exports__